import { FC } from 'react';
import { WrapInLayout } from '../layouts';
import OrderList from '../components/orders/OrderList';

const RecentOrdersPage: FC = () => (
  <WrapInLayout title="Recent Orders" layout="dashboard">
    <h1 className="text-xl font-semibold mb-3">Recent Orders</h1>
    <OrderList />
  </WrapInLayout>
);

export default RecentOrdersPage;
